export const quoter_config = {
  local_storage_data: false,
  redirection_url: "/products",
  url_global: "http://localhost:4200/ar/productos",
  redirection: true,
  geolocation: false,
  type: "default",
  language: "es",
  market: "global",
  min_days_quotation: 3,
  max_years_quotation: 1,
  pax_limit: 9,
  age_groups: {
    age_1: 74,
    age_2: 75,
  },
  days_limit: 120,
  mode: "normal",
  dates: {
    weekdays: false,
  },
  view_mode: "default",
};
